import { ImagilityBaseResponse } from './../../../../data/models/response.model';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, NgForm, FormGroupDirective } from '@angular/forms';
import { LookupService } from 'src/app/services/lookup-data.service';
import { USER_PERMISSIONS } from 'src/app/data/constants/permissions';
import * as errorUtils from 'error-message-utility';
import { select, Store } from '@ngrx/store';
import { getSubTaskDetails, getSuperTask, loadSubTaskDetails, updateStepStatusToInitialState } from 'visa-store';
import { ToastrService } from 'ngx-toastr';
import {
  ServiceCenterDetails, SignatoryDetails, SubTaskDetails, ReferenceLibrary,
  I140FileUploadConfiguration, PrimaryData, SuperTask
} from 'app-models';
import { Subject } from 'rxjs/internal/Subject';
import { take, takeUntil } from 'rxjs/operators';
import { combineLatest, Subscription } from 'rxjs';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { ReferenceLibraryService } from 'reference-library';
import { VisaExtendedState } from '../../utility/interfaces/visa-extended-state';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { ActivatedRoute, Router } from '@angular/router';
import { I130Service } from 'src/app/modules/superTask/components/create-task/sub-task/i130/i130.service';
import { PetitionUpdateInitComponent } from '../update-petition-dialogue/petition-update-init/petition-update-init.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { APIUpdateSubTask } from '../update-sub-task-details/update-sub-task-details.service';
import { TaskUtilityService } from 'src/app/modules/utility/task-utility.service';
import { PetitionUpdateInitService } from '../update-petition-dialogue/petition-update-init.service';
import { UploadDocumentService } from 'src/app/services/upload-document.service';
import { StepTaskAllocationComponent } from 'src/app/modules/task-allocation/step-task-allocation/step-task-allocation.component';
import { AppServicesLibraryService } from 'app-services-library';
import { DEPENDENT_VISAS, SubTask } from 'app-models';
import moment from 'moment';
import { CacheCountryListService } from 'cache-country-list';
import { CustomQuestionnaireService } from 'src/app/modules/custom-questionaire/services/custom-questionnaire.service';
import { getSubTaskList } from 'src/app/modules/superTask/task-state/reducers/task.reducer';

@Component({
  selector: 'app-update-sub-task-details',
  templateUrl: './update-sub-task-details.component.html',
  styleUrls: ['./update-sub-task-details.component.scss']
})
export class UpdateSubTaskDetailsComponent implements OnInit, OnDestroy {

  @Output()
  subTaskPanelToggleEvent: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(StepTaskAllocationComponent) stepTaskAllocationComponent: StepTaskAllocationComponent;

  subtaskForm: NgForm;
  taskForm: FormGroup = new FormGroup({});
  petitionTaskForm;
  disabledControls = false;
  isOutsideImagility = true;
  fileUploadConfigurations: I140FileUploadConfiguration;
  attorneyPreparerEmployeeList: any; // Attorney company users list
  serviceCenterList: ServiceCenterDetails[];
  signatoryEmployeeList: SignatoryDetails[];
  attorneyFirmList: Array<{ attorneyId: number; attorneyName: string; }>;
  petitionerPreparerEmployeeList: any;
  //task: SubTaskDetails;
  task: any;
  userType: string;
  @Input() taskTypeCode: string;
  observableSubscription$ = new Subject();
  fields: {
    showAdditionalAnswerForQuestions: boolean;
    showDividerBeforeForeignCompany: boolean;
    showForeignCompany: boolean;
    showRelationshipOfUSCompanyWithForeignCompany: boolean;
    showTreatyCountry: boolean;
    showSignatoryAndDesignation: boolean;
    disableProcessingType: boolean;
    showProcessingSection: boolean;
    showQuestionSection: boolean;
    showConsulateSection: boolean;
    showExtraordinarySection: boolean;
  } = {
      showAdditionalAnswerForQuestions: false,
      showDividerBeforeForeignCompany: false,
      showForeignCompany: false,
      showRelationshipOfUSCompanyWithForeignCompany: false,
      showTreatyCountry: false,
      showSignatoryAndDesignation: true,
      disableProcessingType: false,
      showProcessingSection: true,
      showQuestionSection: true,
      showConsulateSection: false,
      showExtraordinarySection: false
    };
  petitionUpdates: boolean[] = [false, false];
  isPUExpanded = false;
  puPanelOpenState = false;
  isFormEditable = true;
  dialogRef: MatDialogRef<PetitionUpdateInitComponent, any>;
  subcriptions: Subscription[] = [];
  questionList = [];
  immiStatus = [];
  visaTypes = [];
  petitionTypes = [];
  immigrantType = '';
  taskNonEdit = {
    companyName: '',
    beneficiaryEmployeeName: '',
    visaTypeName: '',
    petitionTypeName: '',
    serviceCenterName: '',
    authorizedSignatoryName: '',
    attorneyName: '',
    preparerAttorneyName: '',
    immSpecialistName: ''
  };
  selectedCompanyId = '';
  inputData: PrimaryData;
  changeServiceCenterEdit = false;
  alteredServiceCenterId = null;
  configurations;
  changedServiceCenterFileUploaded: any;
  uscisObj = {
    changeUscisChecked: false
  };


  receiptNumber;
  changeServiceCenter: boolean;
  casetransferReceiptfileName: string;
  foreignCompanyList: any[] = [];
  companyRelationList: ReferenceLibrary[] = [];
  fieldExtrAbltyCodeList: ReferenceLibrary[] = [];
  extraBLDOCEVDNCATGList: ReferenceLibrary[] = [];
  majorInternationAwardList: any[] = [];
  fieldExtrAbltyCode;
  visaTypeArray = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'TN1', 'TN2', 'H1-B'];
  OVisaTypeArray = ['O1A', 'O1B'];
  additionalInfoTextAnswerRequiredVisaTypeArray = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'O1A', 'O1B', 'TN1', 'TN2'];
  taskType: string;
  immClassificationCode: string;
  superTask: SuperTask;
  employeeDetails: any;
  selectedValue: any;

  index = 0;
  taskAllocationId = 0;
  taskdueDate: string;
  countryList: any;
  consulateList: any;
  consulate: any;
  overviewSubTaskData: any[];
  treatyCountryList : any[] = [];
  constructor(
    private lookupService: LookupService,
    private toastr: ToastrService,
    private store: Store<VisaExtendedState>,
    private petitionerService: PetitionerService,
    private referenceLibraryService: ReferenceLibraryService,
    private stepStatusUpdatePayloadService: StepStatusUpdatePayloadService,
    private route: ActivatedRoute,
    private i130Service: I130Service,
    public dialog: MatDialog,
    private apiService: APIUpdateSubTask,
    private utilityService: TaskUtilityService,
    private petitionUpdateInitService: PetitionUpdateInitService,
    private uploadDocumentService: UploadDocumentService,
    private router: Router,
    private fb: FormBuilder,
    private appServicesLibraryService: AppServicesLibraryService,
    public cacheCountryService: CacheCountryListService,
    public customQuestionnaireService: CustomQuestionnaireService,
  ) {
    this.attorneyPreparerEmployeeList = [];
    this.serviceCenterList = [];
    this.signatoryEmployeeList = [];
    this.attorneyFirmList = [];
    this.petitionerPreparerEmployeeList = [];
    this.userType = sessionStorage.getItem('userTypeRole');
    this.selectedCompanyId = sessionStorage.getItem('selectedCompanyId');
    this.changeServiceCenter = true;
  }

  ngOnInit() {
    if (this.userType === 'Beneficiary') {
      this.disabledControls = true;
    }
    if (this.route.snapshot.paramMap.has('taskType') && this.route.snapshot.paramMap.get('taskType') === 'I130') {
      this.store.pipe(select(getSuperTask))
        .pipe(take(1))
        .subscribe((data: SuperTask) => {
          this.superTask = data;

        });
    }

    // Get Sub task Details
    this.store.pipe(select(getSubTaskDetails))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: SubTaskDetails) => {
        if (data && data.id) {
          const extrAblDocEvdList = data.extrAblDocEvdList ? data.extrAblDocEvdList.map(x => x.code) : null;
          data = {
            ...data,
            extrAblDocEvdList
          };
          const stepIDSet = new Set(data.taskCustomStepDetails.map((item) => item.stepId));
          const masterData = this.customQuestionnaireService.masterData.customStepList.filter((item) => !stepIDSet.has(item.id));
          const mergedData = [...data.taskCustomStepDetails, ...masterData];

          data.taskCustomStepDetails = mergedData;
          this.task = data;
          this.consulate = data['consulate'];
          this.receiptNumber = this.task.receiptNumber;
          this.casetransferReceiptfileName = this.task.casetransferReceiptfilePath ?
            this.task.casetransferReceiptfilePath.replace(/^.*[\\\/]/, '') : null;
          this.fileUploadConfigurations = Object.assign({}, {
            disableControls: false,
            isDocumentTypeRequired: false,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getApiUrl: `/document/taskStep/0/category/RECPET/entity/0/fileCategory/RECCASETRN?taskId=${this.task.id}`,
            postApiUrl: `/document/taskStep/${this.task.id}/category/RECPET/entity/${this.receiptNumber}/fileCategory/`,
            deleteApiUrl: `/document/taskStep/0/receipt/`,
            documentTypeDropdownCode: 'RECCASETRN'
          });
          this.disabledControls = this.userType === 'Beneficiary' || data.taskStatus.code === 'FILED';
          if (this.route.snapshot.paramMap.has('visaType')) {
            this.taskType = this.task.taskTypeDetails.visaType ? this.task.taskTypeDetails.visaType : this.task.taskTypeDetails.immCategoryCode;
          } else if (this.route.snapshot.paramMap.has('taskType')) {
            this.taskType = this.route.snapshot.paramMap.get('taskType');
          }
          switch (this.taskType) {
            case 'L1A':
            case 'L1B':
              this.fields = {
                showAdditionalAnswerForQuestions: true,
                showDividerBeforeForeignCompany: true,
                showForeignCompany: true,
                showRelationshipOfUSCompanyWithForeignCompany: true,
                showTreatyCountry: false,
                showSignatoryAndDesignation: true,
                disableProcessingType: false,
                showProcessingSection: true,
                showQuestionSection: true,
                showConsulateSection: false,
                showExtraordinarySection: false
              };
              break;
            case 'E1':
            case 'E2':
            case 'E2C':
              this.fields = {
                showAdditionalAnswerForQuestions: true,
                showDividerBeforeForeignCompany: true,
                showForeignCompany: true,
                showRelationshipOfUSCompanyWithForeignCompany: true,
                showTreatyCountry: true,
                showSignatoryAndDesignation: true,
                disableProcessingType: false,
                showProcessingSection: true,
                showQuestionSection: true,
                showConsulateSection: false,
                showExtraordinarySection: false
              };

              break;
            case 'I130':
              this.fields = {
                showAdditionalAnswerForQuestions: false,
                showDividerBeforeForeignCompany: false,
                showForeignCompany: false,
                showRelationshipOfUSCompanyWithForeignCompany: false,
                showTreatyCountry: false,
                showSignatoryAndDesignation: false,
                disableProcessingType: true,
                showProcessingSection: true,
                showQuestionSection: true,
                showConsulateSection: false,
                showExtraordinarySection: false
              };
              break;
            case 'O1A':
            case 'O1B':
              this.fields = {
                showAdditionalAnswerForQuestions: true,
                showDividerBeforeForeignCompany: false,
                showForeignCompany: false,
                showRelationshipOfUSCompanyWithForeignCompany: false,
                showTreatyCountry: false,
                showSignatoryAndDesignation: true,
                disableProcessingType: false,
                showProcessingSection: true,
                showQuestionSection: true,
                showConsulateSection: false,
                showExtraordinarySection: true
              };
              this.getExtraOrdinaryDetailsOVisa();
              break;
            case 'DS160':
              this.fields = {
                showAdditionalAnswerForQuestions: false,
                showDividerBeforeForeignCompany: false,
                showForeignCompany: false,
                showRelationshipOfUSCompanyWithForeignCompany: false,
                showTreatyCountry: false,
                showSignatoryAndDesignation: false,
                disableProcessingType: true,
                showProcessingSection: false,
                showQuestionSection: false,
                showConsulateSection: true,
                showExtraordinarySection: false
              };
              break;
            case 'PWDEFILE':
              this.fields = {
                showAdditionalAnswerForQuestions: false,
                showDividerBeforeForeignCompany: false,
                showForeignCompany: false,
                showRelationshipOfUSCompanyWithForeignCompany: false,
                showTreatyCountry: false,
                showSignatoryAndDesignation: true,
                disableProcessingType: true,
                showProcessingSection: false,
                showQuestionSection: false,
                showConsulateSection: true,
                showExtraordinarySection: false
              };
              this.getAllDropdownList();
              break;
            default:              
              this.fields = {
                showAdditionalAnswerForQuestions: true,
                showDividerBeforeForeignCompany: false,
                showForeignCompany: false,
                showRelationshipOfUSCompanyWithForeignCompany: false,
                showTreatyCountry: false,
                showSignatoryAndDesignation: true,
                disableProcessingType: (DEPENDENT_VISAS.includes(this.taskType) || ['K1', 'K3','U1','UD','I192U','UQ','APPLADCARDNONIM'].includes(this.taskType) || this.task.taskTypeDetails?.immCategory === 'Asylum' || this.task.taskTypeDetails?.immCategory === 'Others' || this.taskType === 'I485' || this.taskType === 'DS160' || ['AMERASIANI360', 'VAWASPOUSEI360', 'VAWACHILDI360', 'VAWAPARENTI360', 'WIDOWERUSI360','APPLADCARDIMM'].includes(this.task.taskTypeDetails?.immClassificationCode)) ? true : false,
                showProcessingSection: true,
                showQuestionSection: true,
                showConsulateSection: false,
                showExtraordinarySection: false
              };
              break;
          }
          if (this.taskType === 'I130') {
             this.getI130DropdownList();
          }else{
            this.getAllDropdownList();
          }

          if (this.taskType === 'DS160' || this.taskType === 'DS260' || this.taskType === 'PWDEFILE') {
            //this.getAllDropdownList();
            this.cacheCountryService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
            this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
              if (data.listCountries.length > 0) {
                this.countryList = data.listCountries;
              } else {
                this.countryList = [];
              }
            });
            this.getConsulateAddressByCountry();
          }

        }
      });
  }

  onServiceCenterClose() {
    this.changeServiceCenterEdit = false;
    this.alteredServiceCenterId = this.task && this.task.updatedServcieCenter ?
      this.task.updatedServcieCenter.newServiceCenmterId : '0';
    // this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

  onChangeServiceCenter() {
    this.configFileUpload();
    this.changeServiceCenterEdit = this.uscisObj.changeUscisChecked;
    if (!this.uscisObj.changeUscisChecked) {
      this.alteredServiceCenterId = this.task && this.task.updatedServcieCenter ?
        this.task.updatedServcieCenter.newServiceCenmterId : '0';
      // this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
  }

  onSercviceCenterEdit() {
    this.configFileUpload();
    this.getDocuments();
    this.changeServiceCenterEdit = true;
    this.uscisObj.changeUscisChecked = true;
    this.alteredServiceCenterId = parseInt(this.task.updatedServcieCenter.newServiceCenmterId);
  }

  handleIsFileListModified(isFileListModified: boolean) {
    if (isFileListModified) {
      this.getDocuments();
    }
  }

  configFileUpload() {
    this.fileUploadConfigurations = Object.assign({}, {
      disableControls: false,
      isDocumentTypeRequired: false,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getApiUrl: `/document/taskStep/0/category/RECPET/entity/0/fileCategory/RECCASETRN?taskId=${this.task.id}`,
      postApiUrl: `/document/taskStep/${this.task.id}/category/RECPET/entity/${this.receiptNumber}/fileCategory/`,
      deleteApiUrl: `/document/taskStep/0/receipt/`,
      documentTypeDropdownCode: 'RECCASETRN'
    });
  }

  onServiceCenterChanged() {
    // this.store.dispatch(new MarkDirtyFormAction({ dirty: true }));
  }

  getDocuments() {
    // this.apiService.getUploadedDocument(`/${this.task.taskTypeDetails.visaType}/${this.taskTypeCode}/${this.task.petitionId}/document/category/TRACKRCPT/`)
    this.apiService.getUploadedDocument(`/document/taskStep/0/category/RECPET/entity/0/fileCategory/RECCASETRN?taskId=${this.task.id}`)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        this.changeServiceCenter = response.data && response.data.length > 0 ? false : true;
      });
  }


  changeUSCIS() {
    const payload = {
      eventTypeCode: 'UPDATEV',
      oldData: this.task.serviceCenterDetails.id,
      newData: this.alteredServiceCenterId,
      taskId: this.task.id,
    };
    this.subcriptions[this.subcriptions.length] = this.petitionUpdateInitService.postupdatedPetition('update/serviceCentre', payload)
      .subscribe((data) => {
        if (data) {
          this.toastr.success(data.message, 'Success');
          // this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          // const API = this.taskType === 'I130' ?
          //   this.petitionerService.getImmigrationTaskDetails(this.task.id) :
          //   this.petitionerService.getTask(this.task.id);
          this.subcriptions[this.subcriptions.length] = this.appServicesLibraryService.getTask(this.taskType, this.task.id)
            .subscribe(response => {
              // this.setTaskDetails(response);
              this.store.dispatch(loadSubTaskDetails({
                taskId: this.task.id,
                visaTypeCode: this.taskType
              }));
              this.changeServiceCenterEdit = false;
            });
        }
      });
  }

  fileUploadSuccess() {
    this.getServiceCenterChangeFile();
    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
  }
  getServiceCenterChangeFile() {
    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetUploadDocument(
      'taskStep', this.task.id, 'RECPET', this.receiptNumber, true)
      .subscribe((responseFileUpload: any) => {
        if (responseFileUpload.status === 200) {
          this.changedServiceCenterFileUploaded =
            responseFileUpload.data.filter(x => x.entityId === this.receiptNumber && x.fileLocation !== null).map(x => {
              return {
                ...x,
                fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, '')
              };
            });
        } else {
          this.changedServiceCenterFileUploaded = [];
        }
      });
  }

  clickRadioBtn() {
    // if(this.task.extrAblDocEvdCatg.code === 'OTHERDOCEVDN'){
    this.task.extrAblDocEvdList = [];
    // }
  }

  getExtraOrdinaryDetailsOVisa() {
    const fieldExtrAbltyCode = this.task.taskTypeDetails.visaType === 'O1A' ? 'O1AFLDEXTRABL' : 'O1BFLDEXTRABL';
    let payload = [];
    if (this.task.taskTypeDetails.visaType === 'O1A') {
      payload = ['OTHERDOCEVDN'];
    } else if (this.task.taskTypeDetails.visaType === 'O1B') {
      payload = ['OTHERDOCEVDN', 'O1BSPECDOCEVDN'];
    }
    combineLatest([
      this.referenceLibraryService.getReferenceData('EXTRABLDOCEVDNCATG'),
      this.referenceLibraryService.postReferenceData(payload),
      this.referenceLibraryService.getReferenceData(fieldExtrAbltyCode)
    ]).pipe()
      .subscribe(data => {
        this.extraBLDOCEVDNCATGList = data[0];
        this.majorInternationAwardList = data[1];
        this.fieldExtrAbltyCodeList = data[2];
        if (this.task.extrAblDocEvdCatg.code === 'MAJINTLAWRDEVDN') {
          this.task.extrAblDocEvdList = [];
        }
        this.petitionTaskForm.patchValue({
          extrAblDocEvdCatgCode: this.extraBLDOCEVDNCATGList[0].code
        });
        // this.petitionTaskForm.patchValue({
        //   extrAblDocEvdCatgCode: this.extraBLDOCEVDNCATGList[0].code
        // });
      });
    // this.subtaskForm.controls.push(this.subtaskForm.group(row));
  }

  getI130DropdownList() {
    const isPremium = this.task.serviceCenterDetails.isPremiumCenter !== 0;
    combineLatest([
      this.i130Service.getServiceCenters(isPremium),
      // this.i130Service.getEmployeeDetails(
      //   parseInt(sessionStorage.getItem('companyId')), parseInt(sessionStorage.getItem('employeeId'))),
      this.i130Service.getEmployeeDetails(
        // parseInt(sessionStorage.getItem('companyId')),
        this.task.attorneyId,
        this.task.preparerAttorneyId),
      // this.lookupService.getUsersOfCompany(parseInt(sessionStorage.getItem('companyId')))
      this.lookupService.getUsersOfCompany(this.task.attorneyId)
    ])
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: any[]) => {
        this.serviceCenterList = data[0];
        // this.attorneyFirmList = data[1];
        this.employeeDetails = data[1];
        this.petitionerPreparerEmployeeList = data[2];
        if (this.task && this.task.immSpecialistId) {
          this.onPetitionerPreparerChange({ value: this.task.immSpecialistId });
        }
      });
  }

  getAllDropdownList() {
    const isPremium = !!(this.task.serviceCenterDetails && this.task.serviceCenterDetails.isPremiumCenter !== 0);
    const requestArray = [
      // this.lookupService.
      //   getSuperTaskServiceCenters((this.task.serviceCenterDetails.isPremiumCenter === 0) ? false : true),


      this.lookupService.getReviewersUser(this.task.companyId, USER_PERMISSIONS.PETITION_REVIEWER),
      this.lookupService.getActiveAttorneyCompanyList(this.task.companyId),
      this.lookupService.getUsersOfCompany(this.task.companyId)
    ];
    if (this.taskType !== 'DS160' && this.taskType !== 'DS260' && this.taskType !== 'PWDEFILE')
      if (this.task.taskTypeDetails.visaType && this.task.taskTypeDetails.petitionType) {
        requestArray.push(this.lookupService.getServiceCenters(
          isPremium,
          this.task.taskTypeDetails.visaType,
          this.task.taskTypeDetails.petitionType))
      } else {
        requestArray.push(this.apiService.getImmiServiceCenters(
          isPremium,
          this.task.taskTypeId
        ))
      }
    if (this.task.taskTypeDetails) {
      switch (this.task.taskTypeDetails.visaType) {
        case 'L1A':
        case 'L1B':
          // if (this.userType === 'Petitioner') {
          requestArray.push(
            this.petitionerService.getPetitionerClientList(this.task.companyId, 'notInCountry'));
          // } else if (this.userType === 'Attorney') {
          //   requestArray.push(
          //     this.petitionerService.getPetitionerClientList(this.task.companyId, 'notInCountry'));
          // }
          break;
        case 'E1':
        case 'E2':
        case 'E2C':
          // if (this.userType === 'Petitioner') {
          requestArray.push(
            this.petitionerService.getForeignCompanyListForEVisa(this.task.taskTypeDetails.visaType, this.task.companyId),this.cacheCountryService.getCountry());

          // } else if (this.userType === 'Attorney') {
          //   requestArray.push(
          //     this.petitionerService.getForeignCompanyListForEVisa(this.task.taskTypeDetails.visaType, this.task.companyId));
          // }
          break;
      }
      requestArray.push(
        this.referenceLibraryService.getReferenceData('USFORGNCOMPREL'));
    }

    combineLatest(requestArray)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: any[]) => {
        this.serviceCenterList = data[3];
        this.signatoryEmployeeList = data[0];
        this.attorneyFirmList = Object.assign([],[{attorneyId:null, attorneyName:"Select attorney"},...data[1]]);
        this.petitionerPreparerEmployeeList = data[2];
        if (this.task && this.task.immSpecialistId) {
          this.onPetitionerPreparerChange({ value: this.task.immSpecialistId });
        }
        if (this.task.taskTypeDetails) {
          switch (this.task.taskTypeDetails.visaType) {
            case 'L1A':
            case 'L1B':
              this.foreignCompanyList = data[4];
              this.companyRelationList = data[5];
              break;
            case 'E1':
            case 'E2':
            case 'E2C':
              this.foreignCompanyList = data[4];
              this.treatyCountryList = data[5];
              this.companyRelationList = data[6];
              break;
          }
        }
        if (this.task.attorneyId > 0) {
          this.onAttorneyFirmChange();
        }
      });
  }

  onChangeProcessingType(processingType: number) {
    this.serviceCenterList = [];
    // this.task.serviceCenterDetails.id = null;
    this.getServiceCenter(processingType);
  }

  getdropdownvalue(e) {
    this.selectedValue = e.originalEvent.target.innerText;
    this.selectedValue = e.value;
  }

  // This code is necessary
  onAttorneyPreparerChange({ value }) {
    const attorneyPreparerEmployee = this.attorneyPreparerEmployeeList
      .find(x => x.id === value);
    this.task.preparerAttorneyName =
      `${attorneyPreparerEmployee.firstName} ${attorneyPreparerEmployee.lastName}`;
  }

  onPetitionerPreparerChange({ value }) {
    const petitionerPreparerEmployee = this.petitionerPreparerEmployeeList
      .find(x => x.id === value);
    this.task.preparePetitionerName =
      `${petitionerPreparerEmployee.firstName} ${petitionerPreparerEmployee.lastName}`;
  }

  getServiceCenter(processingType: number) {
    const isPremium = processingType !== 0;
    const request = this.taskType === 'I130' ?
      this.i130Service.getServiceCenters(isPremium) :
      this.lookupService.getServiceCenters(
        isPremium,
        this.task.taskTypeDetails.visaType,
        this.task.taskTypeDetails.petitionType);
    request
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: ServiceCenterDetails[]) => {
        this.serviceCenterList = data;
      });
  }

  onAttorneyFirmChange(val?) {
    // get users of the selected attorney firm
    // if(val){
    //   this.task.preparerAttorneyId = null;
    // }
    // IM-16923
    this.lookupService.getReviewersUser(this.task.attorneyId,USER_PERMISSIONS.PETITION_REVIEWER)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: Array<any>) => {
        this.attorneyPreparerEmployeeList = data;
        if (this.task && this.task.preparerAttorneyId && !val) {
          this.onAttorneyPreparerChange({ value: this.task.preparerAttorneyId });
        }
      });

  }

  onSignatoryChange({ value }) {
    this.task.signatoryDetails = this.signatoryEmployeeList.find(x => x.id === value);
  }


  postSubTask() {
    let subtaskForm;
    const questionAndResponseDTO = this.task.questionAndResponseDTO && this.task.questionAndResponseDTO.length > 0 ?
      this.task.questionAndResponseDTO.map(x => {
        return {
          ...x,
          answer: x.answer ? 1 : 0
        };
      }) : [];
    if (this.visaTypeArray.includes(this.task.taskTypeDetails.visaType) && this.taskType !== 'DS160') {
      subtaskForm = {
        attorneyId: this.task.attorneyId,
        authorizedSignatoryId: this.task.signatoryDetails.id,
        beneficiaryId: this.task.beneficiaryId,
        companyId: this.task.companyId,
        id: this.task.id,
        immSpecialistId: this.task.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: this.task.preparerAttorneyId,
        questionAndResponseDTO,
        // serviceCenterId: this.task.serviceCenterId,
        serviceCenterId: this.task.serviceCenterDetails?.id,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: this.task.superTaskTypeCode,
        taskTypeCode: this.taskTypeCode,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.visaType : null,
        companyRelationCode: this.task.foreignCompanyRelationCode,
        foreignCompanyId: this.task.foreignCompanyId,
        treatyCountryCode: this.task?.treatyCountryCode,
        stepList: this.stepTaskAllocationComponent?.stepTaskTimelineList || [],
        customStepList: this.stepTaskAllocationComponent?.customStepTaskTimelineList || [],
        taskDueDate: this.taskdueDate
      };
    } else if (this.OVisaTypeArray.includes(this.task.taskTypeDetails.visaType) && this.taskType !== 'DS160') {
      subtaskForm = {
        id: this.task.id,
        attorneyId: this.task.attorneyId,
        authorizedSignatoryId: this.task.signatoryDetails.id,
        beneficiaryId: this.task.beneficiaryId,
        companyId: this.task.companyId,
        immSpecialistId: this.task.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: this.task.preparerAttorneyId,
        questionAndResponseDTO,
        //  serviceCenterId: this.task.serviceCenterId,
        serviceCenterId: this.task.serviceCenterDetails?.id,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: this.task.superTaskTypeCode,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.visaType : null,
        extrAblDocEvdCatgCode: this.task.extrAblDocEvdCatg.code,
        fieldExtrAbltyCode: this.task.fieldExtrAblty.code,
        applicableOptionCodes: this.task.extrAblDocEvdList,
        stepList: this.stepTaskAllocationComponent?.stepTaskTimelineList || [],
        customStepList: this.stepTaskAllocationComponent?.customStepTaskTimelineList || [],
        taskDueDate: this.taskdueDate,
        taskTypeCode: this.task?.subTaskTypeCode
      };
    } else if (this.taskType === 'I130') {
      subtaskForm = {
        attorneyId: this.task.attorneyId,
        authorizedSignatoryId: this.task.signatoryDetails ? this.task.signatoryDetails.id : null,
        beneficiaryId: null,
        companyId: null,
        id: this.task.id,
        immSpecialistId: this.task.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: this.task.preparerAttorneyId,
        questionAndResponseDTO,
        serviceCenterId: this.task.serviceCenterDetails?.id,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: 'IMMPET',
        taskTypeCode: this.taskType,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.visaType : null,
        familyId: this.task.familyId,
        immCategoryCode: this.superTask.immigrationCategory ? this.superTask.immigrationCategory.code : null,
        immClassificationCode: this.superTask.immigrationClassification ? this.superTask.immigrationClassification.code : null,
        sponsorId: this.task.sponsorId,
        stepList: this.stepTaskAllocationComponent?.stepTaskTimelineList || [],
        customStepList: this.stepTaskAllocationComponent?.customStepTaskTimelineList || [],
        taskDueDate: this.taskdueDate
      };
    }
    else {
      subtaskForm = {
        attorneyId: this.task.attorneyId,
        authorizedSignatoryId: this.task.signatoryDetails ? this.task.signatoryDetails.id : null,
        beneficiaryId: this.task.beneficiaryId,
        companyId: this.task.companyId,
        id: this.task.id,
        immSpecialistId: this.task.immSpecialistId,
        immigrantTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immigrationType : null,
        isOutsideImagility: this.task.isOutsideImagility,
        petitionTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.petitionType : null,
        preparerAttorneyId: this.task.preparerAttorneyId,
        questionAndResponseDTO,
        serviceCenterId: this.selectedValue || this.task.serviceCenterId,
        // serviceCenterId: this.task.serviceCenterId,
        superTaskId: this.task.superTaskId,
        superTaskTypeCode: this.task.superTaskTypeCode,
        taskTypeCode: this.taskTypeCode,
        visaTypeCode: this.task.taskTypeDetails ? this.task.taskTypeDetails?.visaType : null,
        immCategoryCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immCategoryCode : null,
        immClassificationCode: this.task.taskTypeDetails ? this.task.taskTypeDetails.immClassificationCode : null,
        companyRelationCode: this.task.foreignCompanyRelationCode,
        foreignCompanyId: this.task.foreignCompanyId,
        taskTypeId: this.task.taskTypeId,
        stepList: this.stepTaskAllocationComponent?.stepTaskTimelineList || [],
        customStepList: this.stepTaskAllocationComponent?.customStepTaskTimelineList || [],
        taskDueDate: this.taskdueDate,
        consulate: this.task.consulate
      };
    }
    // if (this.stepTaskAllocationComponent.customStepTaskTimelineList.length) {

    //   this.store.pipe(select(getSubTaskList))
    //     .pipe(takeUntil(this.observableSubscription$))
    //     .subscribe((data: SubTask[]) => {
    //       this.overviewSubTaskData = data;
    //       if (data[0].customStepOverviewList !== null) {
    //         this.customQuestionnaireService.masterData.customStepList.forEach(element => {
    //           let isAllocatedStep = data[0].customStepOverviewList.find(a => a.stepId === element.id);
    //           if (isAllocatedStep) {
    //             subtaskForm.customStepList.map(d=>(d.taskStepId=d.id, d.id=element.id))

    //             // let updateStepData = subtaskForm.customStepList.find(u => u.id === isAllocatedStep.id)
    //             // updateStepData.taskStepId = isAllocatedStep.id;
    //             // updateStepData.id = element.id;
    //           }
    //         });
    //       }
    //       // subtaskForm.customStepList = [];
    //       this.saveUpdateSubTask(subtaskForm, this.taskType);
    //     });
    // } else {
    //   this.saveUpdateSubTask(subtaskForm, this.taskType)
    // }
    subtaskForm.customStepList.map((step)=>{if(step.stepId){step.taskStepId = step.stepId}})
    this.saveUpdateSubTask(subtaskForm, this.taskType)

  }
  saveUpdateSubTask(subtaskForm, taskType) {
    this.stepStatusUpdatePayloadService.saveUpdateSubTask(subtaskForm, taskType)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          this.toastr.success(response.message, 'Success');
          this.store.dispatch(loadSubTaskDetails({
            taskId: this.task.id,
            visaTypeCode: this.taskType
          }));
        }
      });
  }

  petitionUpdateBtnClickNext() {
    if (this.petitionUpdates.some(item => item)) {
      this.dialogRef = this.dialog.open(PetitionUpdateInitComponent, {
        width: '650px',
        disableClose: true,
        data: {
          modify: this.petitionUpdates,
          task: this.task,
          petitionId: this.task.petitionId,
          receiptNumber: this.task.receiptNumber,
          companyId: this.task.companyId,
          selectedCompanyId: this.selectedCompanyId,
          userType: this.userType,
          immigrantType: this.task.taskTypeDetails.immigrationType,
          questionList: this.questionList,
          serviceCenterName: this.task.serviceCenterDetails.serviceCenterName,
          updatedAttorney: this.task && this.task.updatedAttorney ? this.task.updatedAttorney : null
        }
      });
      this.dialogRef.afterClosed().subscribe(result => {
        this.isPUExpanded = false;
        this.petitionUpdates[0] = false;
        this.petitionUpdates[1] = false;
        this.store.dispatch(loadSubTaskDetails({
          taskId: this.task.id,
          visaTypeCode: this.taskType
        }));
        // this.subcriptions[this.subcriptions.length] = this.apiService.getTask(this.inputData.visatype, this.task.id).subscribe(data => {
        //   // this.setTaskDetails(data);

        //   this.isPUExpanded = false;
        //   this.petitionUpdates[0] = false;
        //   this.petitionUpdates[1] = false;
        // });
      });
      // return dialogRef;
    }
  }


  additionalInfoRequired(group): boolean {
    if (!this.task.isOutsideImagility && this.additionalInfoTextAnswerRequiredVisaTypeArray.includes(this.task.taskTypeDetails.visaType) &&
      group.answer && !group.additionalInfo) {
      return true;
    }
    return null;
  }
  onQuestionToggle(i, e) {
    if (e) {
      this.task.questionAndResponseDTO[i]['additionalInfo'] = null;
      this.task.questionAndResponseDTO[i]['answer'] = 0;
    } else {
      this.task.questionAndResponseDTO[i]['answer'] = 1;
    }
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleSubTaskPanelToggle() {
    this.subTaskPanelToggleEvent.emit(false);
  }

  onCancel() {
    this.store.dispatch(loadSubTaskDetails({
      taskId: this.task.id,
      visaTypeCode: this.taskType
    }));
  }

  navigateToDashboard() {
    if (this.userType === 'Attorney') {
      this.router.navigate(['attorney-landing/dashboard/attorney-dashboard']);
    } else {
      this.router.navigate(['petitioner-landing/dashboard/petitioner-dashboard']);
    }
  }


  stepStepTime() {
    this.index = 1;
    // if (this.stepTaskAllocationComponent) {
    //   this.stepTaskAllocationComponent.ngOnInit();
    // }
  }

  handleChange(e) {
    this.index = e.index;
    const queryParamsObj = {
      taskAllocationId: this.taskAllocationId || 0,
      ti:this.index
    };
    this.router.navigate(['./'], { queryParams: queryParamsObj, relativeTo: this.route });
  }
  getConsulateAddressByCountry() {
    const countryCode = this.task.consulate.countryCode.countryCode
    this.lookupService.getConsulateAddressByContry(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      this.consulateList = data;
    });
  }

  onConsulateChange(id) {
    this.consulate = this.consulateList.find(item => item.id === id);
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }
  receiveMessage($event) {
    this.taskdueDate = moment($event).format('YYYY-MM-DD');
  }
}